import CampaignModel from "@/model/CampaignModel.js";

export default function CategoryModel(dict) {
    this.count = dict.count;
    this.id = dict.id;
    this.image_url = dict.image_url_active;
    this.image_url_inactive = dict.image_url_inactive;
    this.list_config = dict.list_config;
    this.mode = dict.mode;
    this.name = dict.name;
    this.name_en = dict.name_en;
    this.name_th = dict.name_th;
    this.tags = dict.tags;

    if (dict.image_url) {
        this.image_url = dict.image_url + "_active";
        this.image_url_inactive = dict.image_url + "_inactive";
    }

    this.subcats = [];
    if(dict.subcats && dict.subcats instanceof Array) {
        var arrSubCat = dict.subcats;
        if (arrSubCat.length > 0) {
            for(var i = 0; i < arrSubCat.length; i++) {
                this.subcats.push(new CategoryModel(arrSubCat[i]));
            }
        }
    }

    this.campaigns = [];
    if (dict.campaigns) {
        var arrItem = dict.campaigns
        if (arrItem.length > 0) {
            for(var j = 0; j < arrItem.length; j++) {
                this.campaigns.push(new CampaignModel(arrItem[j]));
            }
        }
    }

    if (dict.CategoryId && dict.CategoryId != 0) {
        this.id = dict.CategoryId;
    }

    if (dict.Name) {
        this.name = dict.Name;
    }

    if (dict.NameEn) {
        this.name_en = dict.NameEn;
    }
}
